import VehicleFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => <GenericCreateForm formLayoutComponent={<VehicleFormLayout />} transformValues={transformValues} />
